'use strict';

export function SitesService($resource) {
  return $resource('/api/sites/:id/:slug', {
    slug: '@slug',
    id: '@_id'
  }, {
    getBySlug: {
      method: 'GET',
      params: {
        slug: '@slug',
        id: 'slug'
      },
      isArray: false
    },
    save: {
      method: 'POST',
      params: {
        slug: '',
        id: '@_id'
      }
    },
    remove: {
      method: 'DELETE',
      params: {
        slug: '',
        id: '@_id'
      },
    },
    update: {
      method: 'PUT',
      params: {
        slug: '',
        id: '@_id'
      },
    }
  });
}

export default angular.module('fplTruescapeComApp.Sites', [])
  .factory('Sites', SitesService)
  .name;



// WEBPACK FOOTER //
// ./client/components/Sites/Sites.service.js